module.exports = __webpack_public_path__ + "img/icon-down.83503ac8.svg";